import { useEffect, useContext, useState } from 'react';
import Grid from '@mui/material/Grid2';
import { Box, Button } from '@mui/material';
import { getReport } from '../../api/reporting';

import { ReportingContext } from './ReportingContainer';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { DataGrid, GridToolbar, gridFilteredSortedRowIdsSelector } from '@mui/x-data-grid';

export const DisplayReport = () => {
  const { reportName, endpoint, endpointParams, navToReportingPage } = useContext(ReportingContext);
  const [report, setReport] = useState([]);
  const [reportColumns, setReportColumns] = useState([]);

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const day = String(date.getDate()).padStart(2, '0'); // 26
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 02 (Months are 0-based)
    const year = String(date.getFullYear()).slice(-2); // 25
    const hours = String(date.getHours()).padStart(2, '0'); // 09
    const minutes = String(date.getMinutes()).padStart(2, '0'); // 51
    const seconds = String(date.getSeconds()).padStart(2, '0'); // 25

    return `${day}/${month}/${year} - ${hours}:${minutes}:${seconds}`;
  };
  useEffect(() => {
    const fetch = async () => {
      const rawData = await getReport(endpoint, endpointParams);

      const reportData = rawData.map((row, i) => {
        const newRow = { ...row, id: i };

        if (row['Last Modified']) {
          newRow['Last Modified'] = formatDate(row['Last Modified']);
        }

        return newRow;
      });

      setReport(reportData);
      setReportColumns(
        Object.keys(reportData?.[0] || {})
          .filter((k) => k !== 'id')
          .map((k) => {
            return {
              field: k,
              headerName: k === 'Last Modified' ? 'Last Modified' : k,
              headerClassName: 'theme--header',
              // **no** renderCell/valueFormatter on the date column
            };
          })
      );
    };
    fetch();
  }, []);

  const getRowsFromCurrentPage = ({ apiRef }) => gridFilteredSortedRowIdsSelector(apiRef);

  return (
    <Grid className="two-column-divs right-container">
      <Box
        sx={{
          mb: 6,
          mt: 2,
          fontSize: '24px',
          fontWeight: '100',
          fontFamily: 'Roboto',
        }}
        className="header-search"
      >
        <span>{reportName}</span>
      </Box>
      <DataGrid
        rows={report}
        columns={reportColumns}
        pageSizeOptions={[5, 10]}
        key={0}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        slots={{ toolbar: GridToolbar }}
        slotProps={{
          toolbar: {
            printOptions: { disableToolbarButton: true },
            csvOptions: { getRowsToExport: getRowsFromCurrentPage },
          },
        }}
        sx={{ border: 0 }}
      />
      <Button
        sx={{ width: '80px' }}
        variant="text"
        startIcon={<ArrowBackIosIcon />}
        onClick={() => navToReportingPage(null)}
      >
        Back
      </Button>
    </Grid>
  );
};
